import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="relative flex min-h-screen items-center overflow-hidden bg-navy pt-[88px] text-white">
        <div className="grid-texture pointer-events-none absolute inset-0 opacity-50" />
        <div className="mx-auto max-w-shell px-6 md:px-12">
          <p className="font-mono text-sm uppercase tracking-[0.22em] text-energy">
            Error 404
          </p>
          <h1 className="mt-6 font-heading text-6xl font-semibold tracking-tight md:text-8xl">
            Page not found.
          </h1>
          <p className="mt-6 max-w-md text-lg text-white/65">
            The page you're looking for may have moved or no longer exists.
          </p>
          <Link
            to="/"
            className="mt-10 inline-flex items-center gap-2 bg-electric px-8 py-4 text-sm font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover"
          >
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
